import {
    CardCollection,
    Instance,
    Knot,
    Objekt,
    Promize,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { OrganizationService } from '@services/organizationService';
import { UtilService } from '@services/utilService';
import { VehicleService } from '@services/vehicleService';
import { initCardCollection } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class VehiclesIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'vehicleService',
        'organizationService',
        'utilService',
        'assetService',
        'languageService',
    ] as const;

    vehicleCardCollection!: CardCollection;

    constructor(
        instances: Instance,
        private vehicleService: VehicleService,
        private organizationService: OrganizationService,
        private utilService: UtilService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initVehicleCollection();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-vehicles-new', this.dom, () => {
            this.vehicleService
                .newDialog('organizations', 'organization_id')
                .then(() => {
                    this._drawContent();
                });
        });

        this.helper.iconButton('.btn-site-home', this.dom, () => {
            this.state.goBack('site.home');
        });
    }

    private _initVehicleCollection(): void {
        this.vehicleCardCollection = initCardCollection(
            this.vehicleCardCollection,
            this.dom,
            '.vehicle-collection',
            this.vehicleService,
            {
                entityKey: 'vehicles',
                fetchData: (params) => this.vehicleService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                    params.set('organization_ids', this.organizationIds);
                    params.set(
                        'fields',
                        'id,name,photo,plate_number,traveled_distance_with_unit,unit,' +
                            this.organizationService.getAssociationTableFields(),
                    );
                },
            },
            this._vehicleCardKnot.bind(this),
        )!;
    }

    private _vehicleCardKnot(cardKnot: Knot, vehicle: Objekt): void {
        this._initVehicleShowButton(cardKnot, vehicle);
        this._initCardButtons(cardKnot, vehicle);
        this.utilService.initOrganizationLink(cardKnot, vehicle);
    }

    private _initVehicleShowButton(cardKnot: Knot, vehicle: Objekt): void {
        this.helper.link(
            'a.card',
            cardKnot,
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('vehicles.show', {
                vehicleId: vehicle.get<string>('id'),
            }),
        );
    }

    private _initCardButtons(cardKnot: Knot, vehicle: Objekt): void {
        // let actionsKnot = new Query('.actions', cardKnot).getKnot();
    }
}

export const vehiclesIndexController = app.controller(
    'vehiclesIndexController',
    VehiclesIndexController,
);
